module.exports = __webpack_public_path__ + "static/media/water_craft.baf79f05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/water_craft.svg
// module id = 534
// module chunks = 0